import Model, { belongsTo } from '@ember-data/model';

export default class TeamProjectModel extends Model {
  @belongsTo('team', { inverse: 'teamProjects', async: false }) team;
  @belongsTo('project', { inverse: 'teamProjects', async: false }) project;
}
